export default __webpack_public_path__ + "static/media/logo-dap.84674fb0.svg";